export default "__VITE_ASSET__B_b3NBYa__"